module.exports = __webpack_public_path__ + "static/media/android.2994784f.svg";